import React, { useState, useEffect } from 'react';
import { RefreshCw, WifiOff } from 'lucide-react';
import { checkHealth } from '../services/api';
import { Alert, AlertTitle, AlertDescription } from './ui/alert';
import { Button } from './ui/button';

function ConnectionStatus() {
  const [isConnected, setIsConnected] = useState(null);

  useEffect(() => {
    const check = async () => {
      try {
        await checkHealth();
        setIsConnected(true);
      } catch {
        setIsConnected(false);
      }
    };
    check();
    const interval = setInterval(check, 5000);
    return () => clearInterval(interval);
  }, []);

  if (isConnected !== false) return null;

  return (
    <Alert variant="destructive" className="mb-4 flex items-start justify-between gap-4">
      <WifiOff />
      <div className="flex-1">
        <AlertTitle>Backend service offline</AlertTitle>
        <AlertDescription>
          Cannot connect to the monitoring backend. Start it with{' '}
          <code className="rounded bg-muted px-1.5 py-0.5 font-mono text-xs">
            cd backend && python main.py
          </code>
        </AlertDescription>
      </div>
      <Button
        variant="outline"
        size="sm"
        onClick={() => window.location.reload()}
        className="border-destructive/40 text-destructive hover:bg-destructive/10 hover:text-destructive"
      >
        <RefreshCw />
        Retry
      </Button>
    </Alert>
  );
}

export default ConnectionStatus;
